var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{style:('height: '+_vm.size+';'),attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"indeterminate":true,"size":"64","color":"accent"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }